import * as angular from 'angular';
import * as moment from 'moment';

function age() {
    return {
        template: '<span ng-if="valid">{{years}}y {{months}}m {{days}}d</span>',
        restrict: 'E',
        scope: {dob: '<'},
        controller: function ($scope) {

            $scope.$watch(() => $scope.dob, function (value) {
                if (!value) {
                    $scope.valid = false;
                    return;
                }
                let dob = moment(value);

                let age = moment.duration(moment().diff(dob));
                $scope.years = age.years();
                $scope.months = age.months();
                $scope.days = age.days();
                $scope.valid = true;
            })
        },
    };
}

export default angular.module('directives.age', [])
    .directive('age', age)
    .name;
